import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'gradient',
    type: 'default',
  },
  input: {
    label: 'default',
  },
  amountInput: {
    variant: 'standard',
    border: 'standard',
  },
  errors: {
    position: 'top',
    type: 'container',
  },
  balance: {
    visible: true,
  },
};
